import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {CursorType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/cursor/CursorType';
import {BindingConfig, BindingIconPlace, BindingTooltipPlace} from '@mintdata/mint-kit/api/properties/BindingConfig';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {ABooleanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ABooleanConfig';
import {AStringEnumConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AEnumConfig';
import {AStringConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AStringConfig';
import * as React from 'react';

export class CursorModel
{
    @Property<ABoolean>({
        title: 'Cursor enabled',
        tip: 'Cursor enabled',
        isRequired: true,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean,
        binding: BindingConfig.with(null, BindingIconPlace.RightMiddle, BindingTooltipPlace.Right)
    })
    isEnabled:ABoolean;

    @Property<CursorType>({
        title: 'Cursor Type',
        tip: `Cursor Type`,
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: CursorType
    })
    type:CursorType;

    @Property<AString>({
        title: 'Cursor Url',
        tip: `Cursor Url`,
        isRequired: true,
        typeConfig: AStringConfig,
        typeCtor: AString
    })
    url:AString;

    public constructor(isEnabled:ABoolean,
                       type:CursorType,
                       url:AString)
    {
        this.isEnabled = isEnabled;
        this.type = type;
        this.url = url;
    }

    public static default():CursorModel
    {
        return new CursorModel(
            ABoolean.false(),
            CursorType.default(),
            AString.fromString('https://mintdata.com/images/favicon.png'),
        );
    }

    public toCssString():string
    {
        if( !this.isEnabled.value ) return null;

        return CursorType.isCustom(this.type)
            ? `url(${this.url.value.trim()}), auto`
            : this.type.value.value;
    }
}
